import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellsSizeS from './IconWells_size_s';

const props: CreateIconArguments = {
  l: IconWellsSizeS,
  m: IconWellsSizeS,
  s: IconWellsSizeS,
  xs: IconWellsSizeS,
  name: 'IconWells',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
